<app-default-progress-bar
	*ngIf="loadsList == null || updatingLoad || isLoadingLoadsList"
></app-default-progress-bar>

<table
	(matSortChange)="sortData($event)"
	[dataSource]="dataSource"
	[matSortActive]="sortField"
	class="mat-elevation-z1 full-width"
	mat-table
	matSort
	matSortDirection="desc"
	matSortDisableClear
>
	<ng-container *ngIf="selectEnabled" matColumnDef="select">
		<th *matHeaderCellDef mat-header-cell fxFlex="4" fxLayoutAlign="start center">
			<mat-checkbox
				(change)="$event ? masterToggle() : null"
				[checked]="selection.hasValue() && isAllSelected()"
				[color]="'primary'"
				[disabled]="IS_NULL_OR_UNDEFINED(dataSource) || dataSource.data.length == 0"
				[indeterminate]="selection.hasValue() && !isAllSelected()"
				class="m-r-1"
			>
			</mat-checkbox>
		</th>
		<td *matCellDef="let row" mat-cell fxFlex="4" fxLayoutAlign="start center">
			<mat-checkbox
				(change)="$event ? selection.toggle(row) : null"
				(click)="$event.stopPropagation()"
				[checked]="selection.isSelected(row)"
				[color]="'primary'"
				class="m-r-1"
			>
			</mat-checkbox>
		</td>
	</ng-container>

	<ng-container matColumnDef="loadNumber">
		<th
			*matHeaderCellDef
			mat-header-cell
			mat-sort-header="reference_number"
			fxFlex="10"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">Load Number</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="10"
			fxLayoutAlign="start center"
		>
			<div [appTruncateTooltip]="element.referenceNumber || '-'" class="truncate_text">
				{{ element.referenceNumber || '-' }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="customer" *ngIf="accountSettings.ROLE_BASED_CUSTOMER_DATA_ACCESS">
		<th *matHeaderCellDef mat-header-cell fxFlex="6" fxLayoutAlign="start center">
			<span class="fs-13 color-black">Customer</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="6"
			fxLayoutAlign="start center"
		>
			<div
				*ngIf="IS_NOT_NULL_OR_UNDEFINED(element.customerName)"
				class="truncate_text"
				[appTruncateTooltip]="element.customerName | titleCase"
			>
				{{ element.customerName | titleCase }}
			</div>
			<div *ngIf="IS_NULL_OR_UNDEFINED(element.customerName)" fxFlex>
				<span (click)="updateCustomer(element)" *ngIf="isHistorical" class="link">Assign</span>
				<div fxFlex fxLayoutAlign="center center" *ngIf="!isHistorical" class="p-r-1">-</div>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="carrier" *ngIf="showCarrierColumn">
		<th
			*matHeaderCellDef
			mat-header-cell
			fxFlex
			fxLayoutAlign="start center"
			#carrierColumnTableHeader
		>
			<span class="fs-13 color-black">Carrier</span>
		</th>
		<td
			*matCellDef="let element; let i = index"
			mat-cell
			fxFlex
			fxLayoutAlign="start center"
			class="full-width"
		>
			<div
				(click)="selectCell({ columnName: 'carrier', data: element })"
				*ngIf="element?.carrierName"
				class="truncate_text"
				[appTruncateTooltip]="element.carrierName"
				fxFlex
				[ngStyle]="{
					width: carrierColumnTableHeader?.nativeElement?.offsetWidth
						? 'calc(' + carrierColumnTableHeader.nativeElement.offsetWidth + 'px)'
						: 'inherit'
				}"
			>
				{{ element.carrierName }}
			</div>
			<div *ngIf="IS_NULL_OR_UNDEFINED(element.carrierName)">
				<app-carrier-selector-dialog-component
					(carrierSelected)="carrierSelected($event, element, i)"
					*ngIf="isHistorical"
					label="Assign"
				>
				</app-carrier-selector-dialog-component>
				<span *ngIf="!isHistorical">-</span>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="pickupDate">
		<th
			*matHeaderCellDef
			mat-header-cell
			mat-sort-header="pickup_date"
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<div class="fs-13 color-black">Pickup Date</div>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span *ngIf="IS_NULL_OR_UNDEFINED(element.pickupDate)" fxLayoutAlign="center center">
				-
			</span>
			<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.pickupDate)" fxLayoutAlign="center center">
				{{ element.pickupDate | date : 'MM/dd/yyyy' }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="deliveryDate">
		<th
			*matHeaderCellDef
			mat-header-cell
			mat-sort-header="delivery_date"
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">Delivery Date</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span *ngIf="IS_NULL_OR_UNDEFINED(element.deliveryDate)" fxLayoutAlign="center center">
				-
			</span>
			<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.deliveryDate)" fxLayoutAlign="center center">
				{{ element.deliveryDate | date : 'MM/dd/yyyy' }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="origin">
		<th
			*matHeaderCellDef
			mat-header-cell
			mat-sort-header="origin_city"
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">Origin</span>
		</th>
		<td *matCellDef="let element" mat-cell fxFlex="8" fxLayoutAlign="start center">
			<div (click)="selectCell({ columnName: 'origin', data: element })">
				{{ element.origin }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="destination">
		<th
			*matHeaderCellDef
			mat-header-cell
			mat-sort-header="destination_city"
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">Destination</span>
		</th>
		<td *matCellDef="let element" mat-cell fxFlex="8" fxLayoutAlign="start center">
			<div (click)="selectCell({ columnName: 'destination', data: element })">
				{{ element.destination }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="trailerType">
		<th
			*matHeaderCellDef
			mat-header-cell
			[disabled]="!isHistorical"
			mat-sort-header="equipment"
			fxFlex="7"
			fxLayoutAlign="start center"
			#equipmentColumnTableHeader
		>
			<span class="fs-13 color-black">Equipment</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="7"
			fxLayoutAlign="start center"
		>
			<div
				fxFlex
				fxLayoutAlign="start center"
				class="truncate_text"
				[appTruncateTooltip]="getTrailerType(element.trailerType)"
				[ngStyle]="{
					'max-width': equipmentColumnTableHeader?.nativeElement?.offsetWidth
						? 'calc(' + equipmentColumnTableHeader.nativeElement.offsetWidth + 'px)'
						: 'inherit'
				}"
			>
				{{ getTrailerType(element.trailerType) }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="allInCost">
		<th
			*matHeaderCellDef
			mat-header-cell
			[disabled]="!isHistorical"
			mat-sort-header="all_in_cost"
			fxFlex="7"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">All In Cost</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="7"
			fxLayoutAlign="start center"
		>
			<div *ngIf="IS_NULL_OR_UNDEFINED(element.price)" fxFlex fxLayoutAlign="center center">-</div>
			<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.price)" fxFlex fxLayoutAlign="start center">
				{{ element.price / 100 | currency : 'USD' }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="priceToShipper">
		<th
			*matHeaderCellDef
			mat-header-cell
			[disabled]="!isHistorical"
			mat-sort-header="price_to_shipper"
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<span class="fs-13 color-black">Price To Shipper</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="8"
			fxLayoutAlign="start center"
		>
			<div
				*ngIf="IS_NULL_OR_UNDEFINED(element.priceToShipper)"
				fxFlex
				fxLayoutAlign="center center"
			>
				-
			</div>
			<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.priceToShipper)" fxLayoutAlign="start center">
				{{ element.priceToShipper / 100 | currency : 'USD' }}
			</div>
		</td>
	</ng-container>

	<ng-container *ngIf="showOffersColumn" matColumnDef="offers">
		<th *matHeaderCellDef mat-header-cell fxFlex="6" fxLayoutAlign="center center">
			<span class="fs-13 color-black p-l-0-5">Carriers Contacted</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="6"
			fxLayoutAlign="start center"
		>
			<div fxFlex fxLayoutAlign="center center">
				<span *ngIf="IS_NULL_OR_UNDEFINED(element.offersCount)">-</span>
				<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.offersCount)" class="p-r-1">
					{{ element.offersCount }}
				</span>
			</div>
		</td>
	</ng-container>

	<ng-container *ngIf="showViewsColumn" matColumnDef="views">
		<th *matHeaderCellDef mat-header-cell fxFlex fxLayoutAlign="start center">
			<span class="fs-13 color-black p-l-0-25">Views</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex
			fxLayoutAlign="start center"
		>
			<div fxFlex fxLayoutAlign="center center">
				<span *ngIf="IS_NULL_OR_UNDEFINED(element.viewsCount)">-</span>
				<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.viewsCount)" class="p-r-1">
					{{ element.viewsCount }}
				</span>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="bidCount">
		<th *matHeaderCellDef mat-header-cell fxFlex fxLayoutAlign="start center">
			<span class="fs-13 color-black m-r-1">Carrier Offers</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex
			fxLayoutAlign="start center"
		>
			<span *ngIf="IS_NULL_OR_UNDEFINED(element.bidCount)">-</span>
			<p *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.bidCount)">
				<span
					class="primary-light"
					matBadge="{{ element.bidCount }}"
					matBadgeOverlap="false"
				></span>
			</p>
		</td>
	</ng-container>

	<ng-container *ngIf="!showPredictedPriceColumn" matColumnDef="loadStatusText">
		<th *matHeaderCellDef mat-header-cell fxFlex="7" fxLayoutAlign="start center">
			<span class="fs-13 color-black p-l-0-25">Load Status</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="7"
			fxLayoutAlign="start center"
		>
			<span *ngIf="IS_NULL_OR_UNDEFINED(element.loadStatusText)">-</span>
			<mat-chip-list *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.loadStatusText)">
				<mat-chip [ngClass]="element.loadStatusClass">
					{{ element.loadStatusText }}
				</mat-chip>
			</mat-chip-list>
		</td>
	</ng-container>

	<ng-container *ngIf="showPredictedPriceColumn" matColumnDef="predictedPrice">
		<th *matHeaderCellDef mat-header-cell fxFlex fxLayoutAlign="start center">
			<span class="fs-13 color-black">Predicted Price</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex
			fxLayoutAlign="start center"
		>
			<span *ngIf="IS_NULL_OR_UNDEFINED(element.predictedPrice)">-</span>
			<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(element.predictedPrice)">
				{{ TO_DOLLARS(element.predictedPrice) | currency : 'USD' }}
			</span>
		</td>
	</ng-container>

	<ng-container *ngIf="showUserColumn" matColumnDef="user">
		<th *matHeaderCellDef mat-header-cell fxFlex="9" fxLayoutAlign="start center">
			<span class="fs-13 color-black">User</span>
		</th>
		<td
			*matCellDef="let element"
			class="cursor-default"
			mat-cell
			fxFlex="9"
			fxLayoutAlign="start center"
		>
			{{ element.userDTO?.firstName }} {{ element.userDTO?.lastName }}
		</td>
	</ng-container>

	<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
	<tr
		(click)="storeLoadUrl(row)"
		*matRowDef="let row; columns: displayedColumns"
		class="row-hover"
		mat-row
	></tr>
</table>

<mat-paginator
	(page)="getLoads()"
	*ngIf="numberOfLoads > pageSize"
	[length]="numberOfLoads"
	[pageSizeOptions]="[pageSize]"
	class="mat-elevation-z8"
	showFirstLastButtons
>
</mat-paginator>
